import { memo } from 'react';

import { ROLE_TYPES } from '../../constants/roles';
import RoleGroup from './RoleGroup';

const GROUP_ORDER = [ROLE_TYPES.SYSTEM, ROLE_TYPES.CUSTOM];

/**
 * The Roles list: System Roles first, then Custom Roles.
 *
 * @param {object} props
 * @param {{ system: object[], custom: object[] }} props.groups
 * @param {(roleId: string) => void} props.onOpen
 */
const RolesGroupedList = ({ groups, onOpen }) => (
  <div className="flex flex-col gap-6" data-testid="roles-list">
    {GROUP_ORDER.map((kind) => (
      <RoleGroup key={kind} kind={kind} roles={groups[kind]} onOpen={onOpen} />
    ))}
  </div>
);

export default memo(RolesGroupedList);
